import { getFirstMoment, createMomentObjInTimezone } from './dateUtils';

export const LEARN_MORE_HREF = 'https://docs.branch.io/pages/dashboard/people-based-attribution/';

// 1. ANALYTICS eo cutoff date data:
export const TEXT_EO_CUTOFF_ANALYTICS = 'October 14th';
export const ISO_DATE_ANALYTICS = getFirstMoment('2017-10-14T00:00:00');

// calculated from these (don't need to change if date is changed):
export const DATE_EO_CUTOFF_ANALYTICS = createMomentObjInTimezone(ISO_DATE_ANALYTICS);

// 2. EXPORT eo cutoff date data:
// Note: currently these dates are the same as for analytics, but we'd like the
// flexibility to easily change export dates if they end up being different.
export const TEXT_EO_CUTOFF_EXPORT = TEXT_EO_CUTOFF_ANALYTICS;
// Be sure to check out DruidActions if we want these to be different
// as currently it's only using ISO_DATE_ANALYTICS and never ISO_DATE_EXPORT
export const ISO_DATE_EXPORT = ISO_DATE_ANALYTICS;
export const DATE_EO_CUTOFF_EXPORT = createMomentObjInTimezone(ISO_DATE_EXPORT);
